var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95333 5.28536C5 7.23703 5 10.3804 5 16.6654V23.332C5 29.617 5 32.7604 6.95333 34.712C8.90667 36.6637 12.0483 36.6654 18.3333 36.6654H21.6667C27.9517 36.6654 31.095 36.6654 33.0467 34.712C34.9983 32.7587 35 29.617 35 23.332V16.6654C35 10.3804 35 7.23703 33.0467 5.28536C31.0933 3.3337 27.9517 3.33203 21.6667 3.33203H18.3333C12.0483 3.33203 8.905 3.33203 6.95333 5.28536ZM13.3333 15.4154C13.0018 15.4154 12.6839 15.5471 12.4494 15.7815C12.215 16.0159 12.0833 16.3338 12.0833 16.6654C12.0833 16.9969 12.215 17.3148 12.4494 17.5492C12.6839 17.7837 13.0018 17.9154 13.3333 17.9154H26.6667C26.9982 17.9154 27.3161 17.7837 27.5506 17.5492C27.785 17.3148 27.9167 16.9969 27.9167 16.6654C27.9167 16.3338 27.785 16.0159 27.5506 15.7815C27.3161 15.5471 26.9982 15.4154 26.6667 15.4154H13.3333ZM13.3333 22.082C13.0018 22.082 12.6839 22.2137 12.4494 22.4481C12.215 22.6826 12.0833 23.0005 12.0833 23.332C12.0833 23.6636 12.215 23.9815 12.4494 24.2159C12.6839 24.4503 13.0018 24.582 13.3333 24.582H21.6667C21.9982 24.582 22.3161 24.4503 22.5505 24.2159C22.785 23.9815 22.9167 23.6636 22.9167 23.332C22.9167 23.0005 22.785 22.6826 22.5505 22.4481C22.3161 22.2137 21.9982 22.082 21.6667 22.082H13.3333Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentBold);
export default __webpack_public_path__ + "static/media/document-bold.624c01a7fd9713f51fa8894a654659a9.svg";
export { ForwardRef as ReactComponent };